module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chooseType":"Choose"},"es":{"chooseType":"Seleccione"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/New.i18n.json
// module id = lraf
// module chunks = 1